import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";

import {
  RELEASE_STAGE_LABELS,
  RELEASE_STAGES,
  YES_NO_UNKNOWN,
} from "hooks/tivoApps";
import { TiVoDeviceOem, useCreateOem } from "hooks/tivoDevices";
import { FieldProps } from "types/form";
import { toFieldValues } from "utils/formik";
import { pathToUrl } from "utils/url";

import { PATHS } from "../constants";
import { TiVoDeviceForm } from "./components/TiVoDeviceForm";
import { TEXTS } from "./constants";
import { getOemTabs } from "./utils";

type FormType = Omit<TiVoDeviceOem, "id">;

const fields: FieldProps[] = [
  {
    label: TEXTS.OEM_NAME_LABEL,
    name: "name",
  },
  {
    label: TEXTS.OEM_SLUG_LABEL,
    name: "slug",
  },
  {
    label: TEXTS.OEM_RS_LABEL,
    name: "applicableReleaseStages",
    type: "checkbox",
    required: false,
    values: toFieldValues(RELEASE_STAGE_LABELS),
  },
  {
    label: TEXTS.OEM_APPROVAL_LABEL,
    name: "publishingConfirmationRequired",
    type: "radio",
    values: toFieldValues(YES_NO_UNKNOWN),
    required: false,
  },
];

function getInitialValues(platformId?: string): FormType {
  return {
    name: "",
    slug: "",
    platformId: platformId || "",
    applicableReleaseStages: RELEASE_STAGES,
    publishingConfirmationRequired: "unknown",
  };
}

export function TiVoOemAdd() {
  const navigate = useNavigate();
  const { platformId } = useParams();
  const createOem = useCreateOem(platformId);

  async function handleSubmit(values: FormType) {
    createOem.mutate(values, {
      onSuccess: (data) => {
        navigate(
          pathToUrl(PATHS.detailsOem, { platformId, oemId: data.results.id })
        );
      },
    });
  }

  return (
    <TiVoDeviceForm<FormType>
      updateData={createOem}
      fields={fields}
      formData={getInitialValues(platformId)}
      header={TEXTS.OEM_HEADER_NEW}
      onSubmit={handleSubmit}
      tabs={getOemTabs(platformId)}
    />
  );
}
